<template>
  <v-list-item
    v-bind="props"
    ref="link"
    :active="isHovered"
    @click="trackEvent({ event: 'gaEvent', eventCategory: 'Navigation', eventLabel: '' })"
  />
</template>

<script setup lang="ts">
interface Props {
  class?: object | object[] | string | undefined
  title: string
  to?: string | undefined
  href?: string | undefined
}

defineOptions({
  inheritAttrs: false,
})

const _props = defineProps<Props>()
const props = useDefaults(_props, 'HeaderMenuLink')

const linkRef = useTemplateRef<HTMLLinkElement>('link')
const isHovered = useElementHover(linkRef)
const { trackEvent } = useGtm()
</script>
